import React from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import ThemeProvider from '@influitive/secret-garden/lib/theme-provider';

import App from './app';

const Index = ({ level, levels, badges, activeTab }) => (
  <ThemeProvider theme={window._inflTheme}>
    <App level={level} existingLevels={levels} allBadges={badges} activeTab={activeTab} />
  </ThemeProvider>
);

Index.propsTypes = {
  level: PropTypes.object.isRequired,
  levels: PropTypes.array.isRequired,
  badges: PropTypes.array.isRequired,
  activeTab: PropTypes.string
};

const load = props => (
  document.getElementById('infl-fe-level-form') && render(
    <Index {...props} />,
    document.getElementById('infl-fe-level-form')
  )
);


window.inflLoader = window.inflLoader || {};
window.inflLoader = { ...window.inflLoader, loadLevelForm: load };
